<template>
  <section
    id="pain-points"
    class="pain-points"
  >
    <div class="container">
      <div class="section-title">
        <h2>传统硬件设计面临的挑战</h2>
        <p>DesignPulse解决行业核心痛点，推动硬件设计进入AI时代</p>
      </div>
      <div class="points-container">
        <div class="point-card">
          <div class="point-icon">
            <i class="fas fa-clock" />
          </div>
          <h3>设计周期长</h3>
          <p>传统硬件设计需要7大环节，120+天设计周期，严重制约产品上市速度</p>
          <div class="point-data">
            120+ 天
          </div>
        </div>
        <div class="point-card">
          <div class="point-icon">
            <i class="fas fa-user-graduate" />
          </div>
          <h3>依赖资深工程师</h3>
          <p>需要10年+经验的专业工程师，人才稀缺且培养成本高昂</p>
          <div class="point-data">
            10+ 年经验
          </div>
        </div>
        <div class="point-card">
          <div class="point-icon">
            <i class="fas fa-tools" />
          </div>
          <h3>工具成本高昂</h3>
          <p>7个专业工具费用80+万¥/年，Cadence、Mentor、AD垄断90%市场</p>
          <div class="point-data">
            80万+/年
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

</script>

<style scoped>
.pain-points {
  background: var(--gray-50);
}

.points-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 35px;
}

.point-card {
  background: white;
  border-radius: 20px;
  padding: 40px 35px;
  box-shadow: var(--card-shadow);
  transition: var(--transition);
  position: relative;
  overflow: hidden;
  border: 1px solid var(--gray-light);
}

.point-card:hover {
  transform: translateY(-15px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
}

.point-card:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(to right, var(--gray-500), var(--gray-700));
  transition: var(--transition);
  opacity: 0;
}

.point-card:hover:after {
  opacity: 1;
}

.point-icon {
  width: 70px;
  height: 70px;
  background: var(--accent-100);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  color: var(--accent-500);
  font-size: 28px;
  transition: var(--transition);
}

.point-card:hover .point-icon {
  background: linear-gradient(135deg, var(--gray-500), var(--gray-700));
  color: white;
  transform: scale(1.1);
}

.point-card h3 {
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: var(--secondary);
}

.point-card p {
  color: var(--gray);
  margin-bottom: 25px;
  font-size: 1.1rem;
}

.point-data {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--accent-500);
  line-height: 1;
}
</style>
